import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import EditableTable from './EditableTable';
import './InstantBookPricingPopup.css';
import { Button } from '../../../Button';

const MIN_SCROLL = 10;

class InstantBookPricingPopup extends Component {
  state = { modal: false, scrolls: false };

  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  handleScroll() {
    this.setState(prev => ({
      scrolls: prev.scrolls + 1,
    }));
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { instantBookInfo, handleUpdateInstantBookInfo } = this.props;

    const { scrolls } = this.state;
    const disableButton = scrolls < MIN_SCROLL;
    const closeBtn = (
      <button className="close" onClick={this.toggle}>
        <i className="icon icon-close text-blue" />
      </button>
    );

    return (
      <div>
        <a
          className="t-13 d-block text-dark-teal font-weight-normal"
          onClick={this.toggle}
        >
          More Info
        </a>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          onClose={this.handleClose}
          className="instant-book-popup"
          centered
        >
          <ModalHeader toggle={this.toggle} close={closeBtn}>
            Set your instant book pricing
          </ModalHeader>
          <ModalBody className="p-md-5">
            <div className="row">
              <div className="col">
                <p className="font-weight-mid text-gray-mate px-3 pb-4 t-15">
                  Please confirm you have reviewed and set{' '}
                  <a className="text-primary">pricing preferences</a> that you
                  agree to. Frequent cancellations of projects you have been
                  Instant Booked on will result in a lower overall rating.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="instant-book-popup-table-box">
                  <div
                    className="instant-book-popup-table-box-scroll"
                    onScroll={this.handleScroll}
                  >
                    <EditableTable
                      instantBookInfo={instantBookInfo}
                      changeCellChange={handleUpdateInstantBookInfo}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row text-center">
              <div className="col pt-4">
                <p className="text-gray-light t-13">
                  Scroll to end of Pricing Table to confirm you have reviewed
                  your Instant Book prices.
                </p>
                <div className="row">
                  <div className="mt-2 col col-md-4 offset-md-4 text-center">
                    <Button
                      rounded
                      title="I Agree"
                      className="px-4"
                      onClick={this.handleClose}
                      disabled={disableButton}
                    />
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

InstantBookPricingPopup.propTypes = {
  instantBookInfo: PropTypes.array,
  handleUpdateInstantBookInfo: PropTypes.func,
};

export default InstantBookPricingPopup;



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/InstantBook/InstantBookPricingPopup/InstantBookPricingPopup.js